import React, { useMemo, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import {
  Search, BookOpen, Radar, Building2, Upload, ListChecks, PhoneCall, Sparkles,
  Trash2, Download, Globe, Mail, BarChart3, Highlighter, Ban, ChevronRight,
} from "lucide-react";

const SECTIONS = [
  {
    id: "panoramica", icon: BookOpen, title: "Panoramica",
    steps: [
      { t: "Cos'è LeadRadar", d: "Raccogli nominativi di aziende comune per comune, arricchisci i contatti (telefono/email) e invii campagne email tracciate. A sinistra i comuni, al centro la lista aziende, in alto gli strumenti." },
      { t: "Come è organizzata la schermata", d: "Barra laterale: elenco comuni con conteggio aziende. In alto: statistiche, Impostazioni, Richieste, Campagne, Importa CSV, Guida. Sotto: la tabella dei nominativi con ricerca, filtri e azioni." },
    ],
  },
  {
    id: "comuni", icon: Building2, title: "Aggiungere un comune",
    steps: [
      { t: "Nuovo comune", d: "In alto nella barra laterale scrivi il nome del comune nel campo 'Nuovo comune...' e premi il pulsante +. Il comune compare nell'elenco con lo stemma." },
      { t: "Selezionare un comune", d: "Clicca un comune nell'elenco per vedere le sue aziende nella tabella centrale." },
    ],
  },
  {
    id: "raccolta", icon: Radar, title: "Raccogliere aziende (scraping)",
    steps: [
      { t: "Scegli la fonte dati", d: "Sotto 'Fonte dati' scegli: Gratis (OSM + PagineGialle) oppure Google (a pagamento, più completa). La modalità gratis copre bene le aziende con telefono." },
      { t: "Avvia raccolta", d: "Seleziona il comune e premi 'Avvia raccolta'. Puoi lasciare attivo 'Cerca email/telefoni dai siti web' per arricchire automaticamente." },
      { t: "Ricerca per categoria/parola", d: "Usa il campo di ricerca raccolta (es. 'ristoranti', 'immobiliare') per raccogliere aziende di uno specifico settore." },
      { t: "Più raccolte insieme", d: "Puoi avviare la raccolta e nel frattempo continuare a lavorare: il programma raccoglie in background senza bloccare l'interfaccia." },
    ],
  },
  {
    id: "import", icon: Upload, title: "Importare CSV Telemaco",
    steps: [
      { t: "Importa il file", d: "Premi 'Importa CSV Telemaco' in alto e scegli il file. I dati vengono uniti a quelli esistenti senza creare doppioni (per nome e telefono)." },
      { t: "Unione intelligente", d: "Se un'azienda esiste già, i campi mancanti vengono completati con i nuovi dati anziché duplicare la scheda." },
    ],
  },
  {
    id: "gestione", icon: ListChecks, title: "Gestire i nominativi",
    steps: [
      { t: "Modifica al volo", d: "Clicca su telefono, email, indirizzo, note o sul referente sotto il nome azienda per modificarli direttamente. Le modifiche si salvano da sole quando esci dal campo." },
      { t: "Cambiare lo stato", d: "Usa il menu Stato (da fare / chiamato / lavorato) per tracciare la lavorazione di ogni azienda." },
      { t: "Annullare una modifica", d: "Dopo ogni modifica compare in alto a destra 'Modifica salvata' con il pulsante ANNULLA: cliccalo per tornare al valore precedente." },
      { t: "Eliminare un'azienda", d: "Clicca l'icona cestino a fine riga: viene chiesta una conferma prima di eliminare. L'operazione richiede sempre conferma." },
      { t: "Cercare e filtrare", d: "Usa la barra di ricerca sopra la tabella: cerca per nome, telefono, email o INDIRIZZO (es. 'Via Dante' per trovare tutte le aziende di una via). Il menu 'Tutti gli stati' filtra per stato." },
    ],
  },
  {
    id: "contatti", icon: PhoneCall, title: "Trovare contatti mancanti",
    steps: [
      { t: "Trova contatti mancanti", d: "Il pulsante 'Trova contatti mancanti' visita i siti delle aziende per recuperare telefono ed email non presenti." },
      { t: "Cerca contatti AI", d: "'Cerca contatti AI' usa l'intelligenza artificiale per estrarre contatti e il nome del referente dai siti aziendali." },
      { t: "Arricchire una singola scheda", d: "Sull'icona lente di una riga (quando c'è un sito) avvii la ricerca contatti solo per quell'azienda. L'icona sito/Google apre la pagina per copiare i dati a mano." },
    ],
  },
  {
    id: "doppioni", icon: Trash2, title: "Rimuovere i doppioni",
    steps: [
      { t: "Rimuovi doppioni", d: "Il pulsante 'Rimuovi doppioni' elimina automaticamente le schede duplicate (stesso nome o stesso numero di telefono), mantenendo quella più completa." },
    ],
  },
  {
    id: "export", icon: Download, title: "Esportare la lista",
    steps: [
      { t: "Esporta CSV/Excel", d: "Il pulsante 'Esporta CSV/Excel' scarica l'elenco del comune selezionato, pronto per il telemarketing o per altri programmi." },
    ],
  },
  {
    id: "landing", icon: Globe, title: "Landing pubbliche e Richieste",
    steps: [
      { t: "Pagina di presentazione", d: "La landing /presentazione racconta SIACASA e raccoglie richieste dagli imprenditori. Quando si arriva da un'email, l'intestazione si personalizza col nome dell'azienda." },
      { t: "Pagina immobile", d: "La landing /immobile/:id promuove uno specifico immobile e raccoglie richieste di informazioni." },
      { t: "Richieste in arrivo", d: "Il pulsante 'Richieste' in alto apre la casella delle richieste ricevute dalle landing (nome, contatti, messaggio, stato)." },
    ],
  },
  {
    id: "campagne", icon: Mail, title: "Campagne email",
    steps: [
      { t: "Preparare l'invio", d: "Seleziona le aziende con la casella a sinistra, poi premi 'Invia email'. Scegli il tipo: 'Solo presentazione' oppure 'Immobile + presentazione'." },
      { t: "Anteprima", d: "Nel dialog premi 'Anteprima' per vedere l'email esatta (logo, testo, firma di Giorgia) prima di inviarla, con il nome della prima azienda selezionata." },
      { t: "Intestazione e referente", d: "L'email è intestata 'Spettabile [Azienda]' e, se il nominativo ha un referente, aggiunge 'Alla c.a. di [Nome]'." },
      { t: "Invii singoli", d: "Ogni azienda riceve un'email singola e personalizzata (non un invio di gruppo)." },
      { t: "Risposte a Giorgia", d: "Le risposte delle aziende tornano automaticamente alla casella di Giorgia Camesasca." },
    ],
  },
  {
    id: "report", icon: BarChart3, title: "Report campagne",
    steps: [
      { t: "Statistiche", d: "Il pulsante 'Campagne' apre il report con Aperte, Click e Richieste per ogni invio, con le relative percentuali." },
    ],
  },
  {
    id: "evidenziazione", icon: Highlighter, title: "Evidenziazione risposte",
    steps: [
      { t: "Colori in lista", d: "Le righe si colorano in base alla risposta: viola = ha fatto richiesta, verde = ha cliccato, blu = ha aperto, rosso = ha chiesto di sospendere. Un'occhiata e vedi subito le aziende più calde." },
    ],
  },
  {
    id: "sospensione", icon: Ban, title: "Sospensione comunicazioni",
    steps: [
      { t: "Cancellazione richiesta", d: "Se un'azienda chiede di sospendere le comunicazioni, il nominativo NON viene cancellato: viene marcato come sospeso e nelle note viene aggiunta in automatico la data e il motivo, mantenendo le note esistenti." },
    ],
  },
];

export default function UserGuide({ open, onOpenChange }) {
  const [query, setQuery] = useState("");
  const [activeId, setActiveId] = useState(SECTIONS[0].id);
  const q = query.trim().toLowerCase();

  const results = useMemo(() => {
    if (!q) return null;
    return SECTIONS.map((s) => ({
      ...s,
      steps: s.steps.filter((st) => (st.t + " " + st.d).toLowerCase().includes(q) || s.title.toLowerCase().includes(q)),
    })).filter((s) => s.steps.length);
  }, [q]);

  const active = SECTIONS.find((s) => s.id === activeId) || SECTIONS[0];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-hidden p-0 flex flex-col" data-testid="user-guide">
        <DialogHeader className="px-5 pt-5 pb-3 border-b">
          <DialogTitle className="flex items-center gap-2"><BookOpen className="h-5 w-5 text-primary" /> Guida all'utilizzo</DialogTitle>
          <div className="relative mt-3">
            <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input data-testid="guide-search" value={query} onChange={(e) => setQuery(e.target.value)}
              placeholder="Cerca nella guida... (es. 'annulla', 'via', 'anteprima')" className="pl-9 h-10" />
          </div>
        </DialogHeader>

        {results ? (
          <div className="overflow-y-auto px-5 py-4 space-y-5" data-testid="guide-results">
            {results.length === 0 && (
              <p className="text-sm text-muted-foreground text-center py-10" data-testid="guide-no-results">
                Nessun risultato per "{query}".
              </p>
            )}
            {results.map((s) => (
              <div key={s.id}>
                <div className="flex items-center gap-2 text-sm font-semibold text-primary mb-2">
                  <s.icon className="h-4 w-4" /> {s.title}
                </div>
                <div className="space-y-2">
                  {s.steps.map((st, i) => <Step key={i} step={st} />)}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-1 overflow-hidden">
            <nav className="w-56 shrink-0 border-r overflow-y-auto py-2 hidden sm:block" data-testid="guide-nav">
              {SECTIONS.map((s) => (
                <button key={s.id} onClick={() => setActiveId(s.id)} data-testid={`guide-nav-${s.id}`}
                  className={`w-full flex items-center gap-2 px-4 py-2.5 text-sm text-left transition-colors ${
                    s.id === activeId ? "bg-primary/10 text-primary font-medium border-r-2 border-primary" : "hover:bg-muted text-foreground"
                  }`}>
                  <s.icon className="h-4 w-4 shrink-0" /> <span className="truncate">{s.title}</span>
                </button>
              ))}
            </nav>
            <div className="flex-1 overflow-y-auto px-5 py-4">
              <div className="sm:hidden mb-3 flex gap-2 overflow-x-auto pb-2">
                {SECTIONS.map((s) => (
                  <button key={s.id} onClick={() => setActiveId(s.id)}
                    className={`shrink-0 px-3 py-1.5 rounded-full text-xs border ${s.id === activeId ? "bg-primary text-primary-foreground border-primary" : "bg-background"}`}>
                    {s.title}
                  </button>
                ))}
              </div>
              <div className="flex items-center gap-2 text-base font-semibold mb-3">
                <active.icon className="h-5 w-5 text-primary" /> {active.title}
              </div>
              <div className="space-y-2">
                {active.steps.map((st, i) => <Step key={i} step={st} index={i + 1} />)}
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

function Step({ step, index }) {
  return (
    <div className="flex gap-3 rounded-lg border bg-muted/30 p-3">
      {index != null && (
        <span className="shrink-0 h-6 w-6 rounded-full bg-primary text-primary-foreground text-xs font-bold flex items-center justify-center mt-0.5">{index}</span>
      )}
      {index == null && <ChevronRight className="h-4 w-4 text-primary mt-0.5 shrink-0" />}
      <div>
        <p className="text-sm font-medium">{step.t}</p>
        <p className="text-sm text-muted-foreground mt-0.5 leading-relaxed">{step.d}</p>
      </div>
    </div>
  );
}
